export const firebaseConfig = {
    apiKey: "AIzaSyDV8N5d0AJcKfe6O4vmOXfmPHqXZn44K0U",
    authDomain: "travel-guru-ee93d.firebaseapp.com",
    databaseURL: "https://travel-guru-ee93d.firebaseio.com",
    projectId: "travel-guru-ee93d",
    storageBucket: "travel-guru-ee93d.appspot.com",
    messagingSenderId: "683488380209",
    appId: "1:683488380209:web:6b0a8d8ff9a1376bd9dc10"
  };